import { API_BASE_URL } from '../config';

/**
 * Resolve a Customer Identity–stored asset path for use in <img src>.
 * Accepts absolute URLs unchanged; prefixes relative `/uploads/...` paths with the API origin.
 */
export function resolveCiAssetUrl(path) {
  if (!path || typeof path !== 'string') return '';
  const trimmed = path.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const base = String(API_BASE_URL || '').replace(/\/$/, '');
  const p = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base}${p}`;
}
